import { render } from "./Tickets.vue?vue&type=template&id=c5a35d94&scoped=true&ts=true"
import script from "./Tickets.vue?vue&type=script&lang=ts"
export * from "./Tickets.vue?vue&type=script&lang=ts"

import "./Tickets.vue?vue&type=style&index=0&id=c5a35d94&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_seilatv/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5a35d94"]])

export default __exports__